export default "__VITE_ASSET__nXCnvL74adaOpiTcbaW7MQ__"